import { themeShadows } from './themeColors';

export const components = {
  MuiTable: {
    styleOverrides: {
      root: {
        tableLayout: 'auto',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        fontSize: '12px',
        padding: '14px 8px 14px 0px',
      },
      root: {
        fontSize: '14px',
        whiteSpace: 'nowrap',
        padding: '14px 8px 14px 0px',
      },
    },
  },
  MUIDataTableSelectCell: {
    styleOverrides: { root: { paddingLeft: 12 } },
  },
  MUIDataTableHeadCell: {
    styleOverrides: { root: { paddingLeft: 16 } },
  },
  MUIDataTableBodyCell: {
    styleOverrides: { root: { paddingLeft: 8 } },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: '14px',
        textTransform: 'none',
        fontWeight: '600',
        borderRadius: '8px',
        letterSpacing: '0.01em',
      },
      contained: {
        boxShadow: '0 2px 8px rgba(14, 165, 233, 0.25)',
        '&:hover': { boxShadow: '0 4px 12px rgba(14, 165, 233, 0.35)' },
      },
    },
  },
  MuiCssBaseline: {
    styleOverrides: {
      '*': { boxSizing: 'border-box' },
      html: {
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
        height: '100%',
        width: '100%',
      },
      body: { height: '100%' },
      a: { textDecoration: 'none', color: 'inherit' },
      '#root': { height: '100%' },
      '#nprogress .bar': { zIndex: '2000 !important' },
    },
  },
  MuiFab: {
    styleOverrides: { root: { boxShadow: themeShadows[8] } },
  },
  MuiAccordion: {
    styleOverrides: { root: { '&:before': { display: 'none' } } },
  },
  MuiTooltip: {
    styleOverrides: { tooltip: { fontSize: '11px', borderRadius: '6px' } },
  },
  MuiMenuItem: {
    styleOverrides: { root: { fontSize: '0.875rem' } },
  },
  MuiExpansionPanel: {
    styleOverrides: { root: { '&:before': { display: 'none' } } },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06) !important',
        border: '1px solid rgba(226, 232, 240, 0.8)',
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: '6px',
        fontWeight: 600,
        fontSize: '12px',
      },
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        '& .MuiTableCell-root': {
          backgroundColor: '#F8FAFC',
          color: '#475569',
          fontWeight: 700,
          fontSize: '11px',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          borderBottom: '1px solid #E2E8F0',
        },
      },
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: {
        '&:nth-of-type(even)': {
          backgroundColor: 'rgba(248, 250, 252, 0.7)',
        },
        '&:hover': {
          backgroundColor: 'rgba(14, 165, 233, 0.05) !important',
        },
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      rounded: {
        borderRadius: '12px',
      },
    },
  },
};
